import Textfield from "../Input/Textfield";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import { DeliveryMethods } from "@/shared/utils/enum";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import usePosSettingsHook from "@/shared/hooks/usePosSettingsHook";

const HouseNumber = () => {
  const { t } = useTranslation();
  const { register, errors } = useFormContext();
  const [orderUser] = usePosOrderUser();
  const {
    settings: { accept_all_addresses },
  } = usePosSettingsHook();
  const [deliveryMethodId] = usePosOrderDeliveryMethod();

  const isRequiredForDelivery =
    deliveryMethodId === DeliveryMethods.DELIVERY && !accept_all_addresses;

  return (
    <Textfield
      ref={register({
        required: {
          value: isRequiredForDelivery,
          message: t("fieldRequired"),
        },
      })}
      isRequired={isRequiredForDelivery}
      defaultValue={orderUser?.house_number}
      error={errors.order_user?.house_number?.message}
      label={t("posOrders.houseNumber")}
      name="order_user.house_number"
    />
  );
};

export default HouseNumber;
